import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit * 2,
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 3,
  },
  absolute2:{
    position: 'absolute',
    bottom: theme.spacing.unit * 11,
    right: theme.spacing.unit * 2.5,
  }
});


class MyTooltip extends Component {
  
  static propTypes = {

  };

  render() {
    const { classes } = this.props;
    return (
      <div className="home-my-tooltip" onClick={this.props.openDialog}>
        <Tooltip title="Add" aria-label="Add">
          <Fab style={{backgroundColor:"#446cb3", color:"white"}} className={this.props.withChat?classes.absolute2:classes.absolute}>
            <AddIcon />
          </Fab>
        </Tooltip>
      </div>
    );
  }
}


MyTooltip.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MyTooltip);


// WEBPACK FOOTER //
// ./src/features/common/MyTooltip.js